import { render, staticRenderFns } from "./FormWrap.vue?vue&type=template&id=1a69d232&scoped=true&"
import script from "./FormWrap.vue?vue&type=script&lang=js&"
export * from "./FormWrap.vue?vue&type=script&lang=js&"
import style0 from "./FormWrap.vue?vue&type=style&index=0&id=1a69d232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a69d232",
  null
  
)

export default component.exports